import React from 'react';
import { Row } from './Flex';
import Spacer from './Spacer';
import InfoItem from './InfoItem';

const HoursList = ({ title, p }) => {
  if (!p.hours || p.hours.length === 0) return null;
  let hoursElement = (
    <div className="table">
      {p.hours.map(({ days, hours }, i) => {
        return (
          <Row justify="space-between" key={i}>
            <p style={{ flex: 1 }}>{days}</p>
            <Spacer size="small" />
            <p style={{ flex: 1, textAlign: 'right' }}>
              <b>{hours}</b>
            </p>
          </Row>
        );
      })}
    </div>
  );
  return title ? (
    <InfoItem title={title}>{hoursElement}</InfoItem>
  ) : (
    hoursElement
  );

  // let hoursList = (p.hours || []).map(({ days, hours }, i) => {
  //   return [
  //     <div style={{ width: '100%', maxWidth: '300px' }}>
  //       <Row wide key="hours" justify={'space-between'} align="flex-start">
  //         <p style={{ textAlign: 'left', lineHeight: '127%' }}>{days}</p>
  //         <p style={{ textAlign: 'right', lineHeight: '127%' }}>{hours}</p>
  //       </Row>
  //     </div>,
  //     i + 1 === p.hours.length ? null : (
  //       <div key={'spacer'} style={{ height: '4px' }} />
  //     ),
  //   ];
  // });

  // let hoursElement = <Column align="start">{hoursList}</Column>;
  // if (!p.hours || p.hours.length === 0) return null;
  // return title ? (
  //   <InfoItem title={title}>{hoursElement}</InfoItem>
  // ) : (
  //   hoursElement
  // );
};

export default HoursList;
